import React from 'react';
import SimpleEditor from '../common/SimpleEditor';
import './index.css'


export default function Description({ action, elementForm, handleChange }: any) {

  return (
    <React.Fragment>
      <div className='element-form-section'>
        <div className='element-form-section-title'>
          <p>DESCRIPCIÓN</p>
        </div>

        <div className='element-form-section-item__desc'>
          <SimpleEditor
            name='description'
            label='Descripción'
            value={elementForm.description}
            handleChange={handleChange}
            disabled={action === 'view'}
          />
        </div>

      </div>
    </React.Fragment>
  );
}
